import { NavLink } from "react-router-dom";
import ArticleSidebar from "../components/ArticleSidebar";
import "../style/smoke_vs_regression.css";
import titleImg from "../assets/smoke_vs_regression.png"


export default function SmokeVsRegression() {
  return (
    <>
      {/* ================= MAIN CONTAINER ================= */}
      <div className="smoke-vs-regression-container">
        {/* ================= SIDEBAR ================= */}
        <ArticleSidebar />
        <article className="post">
          <h1 className="entry-title">
            Differences between Black Box Testing and White Box Testing
          </h1>

<img src={titleImg} style={{ width: "100%" }} alt="Smoke vs Regression Testing" />t


          <div className="post-content">
            <h2>1. Smoke Testing</h2>
            <p style={{ textalign: "justify" }}>
              <strong>1. </strong>
              <NavLink to="/what-is-smoke-testing" rel="noopener">
                <strong>Smoke Testing</strong>
              </NavLink>
              <strong> :</strong> Smoke Test refers to an initial testing which
              is performed on newly developed software build . By this kind of
              software testing it is clear that the core functionalities of
              software product is working perfectly without any issues. If any
              case the software fails to pass the smoke testing then it is
              treated as broken builds and forwarded back to developers . Some
              testing is done before any functional testing any detailed
              functional tests are done on the software. This smoke testing is
              carried out during initial development stage of{" "}
              <NavLink to="/what-is-sdlc" rel="noopener">
                Software Development Life Cycle (SDLC)
              </NavLink>
              . Smoke Testing is also referred as 'Surface Level Testing' as it
              takes place before actual process testing and does not perform
              deep testing just verifies that core functionalities working fine
              or not. Smoke Testing is not only called as Surface Level Testing
              but also calls 'Build Verification Testing' as it verifies the
              initial builds of software.
            </p>

            <p>
              <strong>Example:</strong>
            </p>
            <p>
              Think about Bus Ticket Reservation Site, in this Smoke Tests
              examples are the tester will ensure that Site Sign in function,
              Changing Password, Booking Seat, Cancel Seat, Booking notification
              functionalities etc. are working fine.
            </p>

            <h2>2. Regression Testing</h2>
            <p>
              <NavLink to="/regression-testing">Regression</NavLink> Testing
              refers to an in depth and through examination of software to
              ensure that recent code change has not adversely affected the
              existing features. Means it is the verification of changes in
              software after bug fixes or changes in requirement. After
              completion of Sanity Testing for changed requirements, Regression
              Testing is carried out to know all the impacted features. Hence
              Regression Testing mainly carried out after any bug fixes, code
              modification, requirement changes, defect fix or any new module
              development. This is done for impact analysis of software after
              any changes.
            </p>

            <p>
              <strong>Example:</strong>
            </p>
            <p>
              If we will take the above same example Regression Testing examples
              include not only the basic functions that make the Bus Ticket
              Reservation site work but allow us to test more complicated use
              cases for seat bookings, like location of travel, promo codes for
              booking, international tax etc.
            </p>

            <h2>Difference between Smoke Testing and Regression Testing</h2>

            <table>
              <thead>
                <tr>
                  <th>Smoke Testing</th>
                  <th>Regression Testing</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Smoke Testing is the Surface Level Testing to verify
                    stability of system.
                  </td>
                  <td>
                    Regression Testing is the Deep Level Testing to verify the
                    rationality of system.
                  </td>
                </tr>
                <tr>
                  <td>Smoke Test is always followed by Regression Test.</td>
                  <td>
                    Regression Test is always carried out throughout the testing
                    phase.
                  </td>
                </tr>
                <tr>
                  <td>
                    Test Cases of Smoke Test is a part of Regression Testing and
                    covers only the core functionalities.
                  </td>
                  <td>
                    Regression testing is obtained from functional specification
                    or Software Requirement Specification (SRS).
                  </td>
                </tr>
                <tr>
                  <td>Smoke tests are performed by the developers.</td>
                  <td>
                    Regression tests are performed by the professional testers.
                  </td>
                </tr>
                <tr>
                  <td>
                    Smoke tests are performed quickly to confirm whether to
                    accept or reject the build.
                  </td>
                  <td>
                    Regression tests are not accountable for accepting or
                    rejecting a software build for further testing procedures.
                  </td>
                </tr>
                <tr>
                  <td>
                    This type of testing is performed on when the new
                    &nbsp;software is developed.
                  </td>
                  <td>
                    This type of testing is performed to check when the change
                    made by tester, code affects the existing features or not.
                  </td>
                </tr>
                <tr>
                  <td>Cost of Smoke testing is low.</td>
                  <td>Cost of Regression testing is little bit high.</td>
                </tr>
                <tr>
                  <td>This testing is documented or scripted.</td>
                  <td>This testing is not documented or scripted.</td>
                </tr>
                <tr>
                  <td>It is also known as Build Verification Testing.</td>
                  <td>It is not known by any other name.</td>
                </tr>
                <tr>
                  <td>
                    Requirement of time and manpower is less than Regression
                    Testing.
                  </td>
                  <td>
                    Requirement of time and manpower is more than Smoke Testing.
                  </td>
                </tr>
                <tr>
                  <td>
                    Smoke testing can be performed by using both automation
                    tools and manually.
                  </td>
                  <td>
                    Regression testing can be performed by either automation
                    tools or manually.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="fusion-meta-info">
              <div className="fusion-meta-info-wrapper">
                By{" "}
                <NavLink className="functional-guide" to="#">
                  Manish Kumar
                </NavLink>{" "}
                | July 10th, 2025 |{" "}
                <NavLink className="functional-guide" to="/testing-types-blog">
                  Testing Types
                </NavLink>
              </div>
            </div>

            <div className="sharing-box">
              <h4>Share This Story, Choose Your Platform!</h4>

              <div className="fusion-social-networks">
                
                <NavLink
                  to="https://www.linkedin.com/in/qa-coder-708418404/"
                  target="_blank"
                  rel="noreferrer"
                  className="linkedin"
                >
                  <i className="fab fa-linkedin-in"></i>
                </NavLink>
                <NavLink
                  to="https://wa.me/918299775823"
                  target="_blank"
                  rel="noreferrer"
                  className="whatsapp"
                >
                  <i className="fab fa-whatsapp"></i>
                </NavLink>
                <NavLink to="mailto:qacoder0@gmail.com" className="email">
                  <i className="fas fa-envelope"></i>
                </NavLink>
                {/* Instagram */}
                <NavLink
                  to="https://www.instagram.com/qacoder0/?hl=en"
                  target="_blank"
                  rel="noreferrer"
                  className="instagram"
                >
                  <i className="fab fa-instagram instagram-gradient"></i>
                </NavLink>

         

              
              </div>
            </div>
          </div>
        </article>
      </div>
    </>
  );
}

